export var resolveNextViteImage = function resolveNextViteImage(png) {
  return typeof png === 'string' ? png : png.src;
};